import { HttpClient } from '../shared/http-client';
import 'rxjs/add/operator/map';
var EnvioService = /** @class */ (function () {
    function EnvioService(httpClient) {
        this.httpClient = httpClient;
    }
    EnvioService.prototype.setEnvio = function (envio) {
        this.envioActual = envio;
    };
    EnvioService.prototype.getEnvio = function () {
        return this.envioActual;
    };
    EnvioService.prototype.listado = function (pagina, cantidadPorPagina, query) {
        // get users from api
        return this.httpClient.get("/envios/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina + "&query=" + query)
            .map(function (response) {
            return response.json();
        });
    };
    EnvioService.prototype.eliminar = function (id) {
        return this.httpClient.delete("/envios/" + id);
    };
    EnvioService.prototype.reenviar = function (id) {
        return this.httpClient.post("/envios/" + id + "/reenviar", null);
    };
    EnvioService.prototype.reenviarComprobantes = function (reenvioComprobantes) {
        return this.httpClient.post("/envios/reenviar", reenvioComprobantes);
    };
    EnvioService.ctorParameters = function () { return [{ type: HttpClient }]; };
    return EnvioService;
}());
export { EnvioService };
//# sourceMappingURL=envio.service.js.map


// WEBPACK FOOTER //
// envio.service.js